import AdminApi from "../../../../../services/api/v2/admin/Admin.api";

export class AdminSettingsModel {
  updateActionRagStatus = async () => {
    await AdminApi.updateActionRagStatus();
  };
}
